module.exports = Em.Handlebars.compile("{{yield}}\n<div class=\"notch\"></div>\n");